export default __webpack_public_path__ + "static/media/cushion_modified.95c602aa.svg";